import { get, post, del } from "../../helpers/utils/http-client";
import { API_PREFIX } from '../../consts/api-endpoints';

export async function getAllAccessKeys() {
    try {
        const { response, status } = await get(`${API_PREFIX}/accounts/access-keys`);
        if (status !== 200) {
            return {pagination: {}, data: []};
        }
        return response;
    } catch (err) {
        console.debug('access-key get-all failed cause', err.message, err.code);
        return {pagination: {}, data: []};
    }
}

export async function createAccessKey(request) {
    try {
        return await post(`${API_PREFIX}/accounts/access-keys`, request);
    } catch (err) {
        console.debug('access-key create failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function deleteAccessKey(keyId) {
    try {
        return await del(`${API_PREFIX}/accounts/access-keys/${keyId}`);
    } catch (err) {
        console.debug('access-key delete failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}